import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../../common/http/fetch-get';
import { getKnowledgeBaseApiConfig } from '../config/actions';
/**
 * @internal
 */
export var fetchManySubEntities = function (entityIds, subEntityType, additionalArgs) { return __awaiter(void 0, void 0, void 0, function () {
    var config, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = getKnowledgeBaseApiConfig();
                url = config.baseUrl + "/v1/groups/" + subEntityType + "?ids=" + entityIds.join('|') + "&marketLocale=" + config.marketLocale;
                if (additionalArgs) {
                    Object.keys(additionalArgs)
                        .forEach(function (key) { url += "&" + key + "=" + additionalArgs[key]; });
                }
                return [4 /*yield*/, fetchGet(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
